import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config/api';
import LoadingSpinner from '../components/LoadingSpinner';
import { typeLabel } from '../config/horseOptions';


const ResultsPage = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const response = await axios.get(`${API}/results`);
        setResults(response.data);
      } catch (error) {
        console.error('Error fetching results:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchResults();
  }, []);

  const groupedResults = results.reduce((groups, result) => {
    const dateKey = new Date(result.end_time).toISOString().split('T')[0];
    if (!groups[dateKey]) {
      groups[dateKey] = { auctions: [] };
    }
    groups[dateKey].auctions.push(result);
    return groups;
  }, {});

  const sortedDateKeys = Object.keys(groupedResults).sort().reverse();

  if (loading) return <LoadingSpinner />;

  return (
    <div className="bg-white min-h-screen" data-testid="results-page">
      <div className="container-custom px-4 py-10 md:py-16 max-w-4xl mx-auto">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-[#0a1628] text-center mb-10" data-testid="results-page-title">
          Risultati dell'asta
        </h1>

        {results.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-[#64748b] text-lg">Nessun risultato disponibile</p>
          </div>
        ) : (
          <div className="space-y-14">
            {sortedDateKeys.map((dateKey) => {
              const group = groupedResults[dateKey];
              const dateLabel = new Date(dateKey + 'T12:00:00').toLocaleDateString('it-IT', {
                day: 'numeric', month: 'long'
              });

              return (
                <div key={dateKey} data-testid={`results-group-${dateKey}`}>
                  <h2 className="font-display text-xl md:text-2xl font-bold text-[#0a1628] text-center mb-8">
                    {dateLabel}
                  </h2>

                  <div className="overflow-x-auto">
                    <table className="w-full" data-testid={`results-table-${dateKey}`}>
                      <thead>
                        <tr className="border-b-2 border-gray-200">
                          <th className="text-left py-3 pr-4 text-xs font-semibold text-[#64748b] uppercase tracking-wide">Cavallo</th>
                          <th className="text-left py-3 pr-4 text-xs font-semibold text-[#64748b] uppercase tracking-wide">Tipo</th>
                          <th className="text-left py-3 pr-4 text-xs font-semibold text-[#64748b] uppercase tracking-wide">Acquirente</th>
                          <th className="text-right py-3 text-xs font-semibold text-[#64748b] uppercase tracking-wide">Prezzo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {group.auctions.map((result) => (
                          <tr key={result.auction_id} className="border-b border-gray-100">
                            <td className="py-3.5 pr-4 text-sm">
                              <a href={`/asta/${result.auction_id}`} className="text-[#0a1628] hover:text-[#0a7e8c] transition-colors">
                                {result.horse?.name || result.title}
                              </a>
                            </td>
                            <td className="py-3.5 pr-4 text-sm text-[#64748b]">
                              {result.horse?.horse_type ? (
                      <>
                        {typeLabel(result.horse.horse_type)}
                        {result.horse.pregnant_with && ` – incinta di ${result.horse.pregnant_with}`}
                      </>
                    ) : '-'}
                            </td>
                            <td className="py-3.5 pr-4 text-sm">
                              {result.winner ? (
                                <span className="text-[#0a1628]">{result.winner.name}</span>
                              ) : result.current_price > result.starting_price ? (
                                <span className="text-[#0a1628]">Ricompra</span>
                              ) : (
                                <span className="text-[#64748b]">Invenduto</span>
                              )}
                            </td>
                            <td className="py-3.5 text-right text-sm">
                              {result.winner || result.current_price > result.starting_price ? (
                                <span className="text-[#0a1628] font-medium">{'\u20AC'}{result.current_price?.toLocaleString()}</span>
                              ) : (
                                <span className="text-[#64748b]">-</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultsPage;
